var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"offline-platform"}},[(!_vm.whatsappStatus)?_c('div',[_c('whatsapp-offline')],1):(_vm.maintenanceStatus)?_c('div',[_c('maintenance')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }